module.exports = "https://coursera_assets.s3.amazonaws.com/images/1bcdc22c3291e23353f77bb856e0bc56.png";